import styles from "./styles.module.scss";

export const SmallDesc = (props) => {
  const {children} = props;

  return <div className={styles.smallDesc}>{children}</div>;
};
